import UploadSpeed from './uploadSpeed.container';

export default UploadSpeed;
